import { createRoutine } from '../common/utils/new-routines';
import type { ShapePreview, SiteUsage } from './types';

export const getContentUsage = createRoutine('liveLinks/GET_CONTENT_USAGE')<
  { contentId: string },
  { contentId: string },
  undefined,
  { result: SiteUsage[] },
  string,
  undefined
>();

export const getPreviewRoutes = createRoutine('liveLinks/GET_PREVIEW_ROUTES')<
  undefined,
  undefined,
  undefined,
  { result: ShapePreview[] },
  string,
  undefined
>();
